

export const API_BASE = process.env.NODE_ENV !== 'development' ? 'https://api.sodenn.directory.sociedadplus.com/api' : 'http://localhost:7040/api';